<mat-toolbar>
  <img id="headerLogo" [src]="headerLogoSrc" alt="Logo">
  <span id="headerSpacer"></span>
  @if (team) {
    <div id="currentTeam" class="flexRowContainer">
      <p class="label-large">{{ team.name }}</p>
    </div>
  }
  @if (user || collaboratorHelperService.isCollaboratorView) {
    <button mat-icon-button id="headerMenuButton"
            (click)="openSettings()" (keydown.enter)="openSettings()"
            aria-label="Settings">
      <mat-icon class="material-icons-outlined">settings</mat-icon>
    </button>
  }
  @if (user) {
    <span id="headerUserMenu" class="userInitialsAvatar title-medium" (click)="openUserMenu()"
          (keydown.enter)="openUserMenu()"
          aria-label="User Menu">
      {{ userInitials }}
    </span>
  }
</mat-toolbar>

@if (userMenuOpen) {
  <app-user-menu [user]="user" (closeUserMenu)="userMenuOpen = false"></app-user-menu>
}

